/**
 * Reducer to manage asynchronous request abortions.
 */

import * as axios from 'axios';

type State = { [type: string]: axios.CancelTokenSource };
type Action = { type: 'cancel/set'; payload: State };

const initialState: State = {};

export const reducer = (state = initialState, action: Action): State => {
    const type = action.type;
    if (type === 'cancel/set') return { ...state, ...action.payload };
    if (!(type in state) || 'payload' in action || 'error' in action) return state;
    state[type].cancel();
    delete state[type];
    return { ...state };
};

export const creators = {};
